<template>
    <div class="calculation" v-if="login">
        <login></login>
    </div>
    <div class="calculation" v-else-if="calculation">
        <table>
            <colgroup>
                <col width="70%">
                <col />
            </colgroup>
            <tr>
                <td></td>
                <td @click="hideCalculation" class="text-right close">X</td>
            </tr>
            <tr>
                <td class="green">Ihr Gebot</td>
                <td class="green">€&nbsp;{{selectedPrice}}</td>
            </tr>
            <tr>
                <td>Auktionsgebühr</td>
                <td>€&nbsp;{{profitSum}}</td>
            </tr>
            <tr>
                <td>MwSt 20%</td>
                <td>€&nbsp;{{vat}}</td>
            </tr>
            <tr><td colspan="2" height="15px"></td></tr>
            <tr>
                <td class="sum">Gesamtsumme</td>
                <td class="sum">€&nbsp;{{total}}</td>
            </tr>
        </table>
        <br>
        <button type="button" class="btn btn-success login w-100" @click="bidSelectedValue" v-if="!ended">Gebot bestätigen</button>
        <div v-else>
            <br>
            Die Zeit für dieses Produkt ist bereits abgelaufen.
            <br><br>
        </div>
        <div class="text">
            Mit der Gebotsabgabe akzeptieren Sie die AGB’s. <br>
            Ihr Gebot ist bindend.
        </div>
    </div>
    <div v-else>
        <div v-if="initialized">
            <div class="dropdown" v-if="!ended">
                <a class="dropdownBTN" href="#" role="button" id="bids" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    {{selected}}
                </a>
                <div class="dropdown-menu" aria-labelledby="bids">
                    <a class="dropdown-item" v-for="price in prices" :key="price.id" @click="selectPrice(price)">{{price}}</a>
                </div>
            </div>
            <button type="button" class="btn btn-success login w-100 bottomZero" @click="checkLogin" v-if="!ended">Gebotsabgabe</button>
            <div class="calculation" v-else>
                <br>
                Die Zeit für dieses Produkt ist bereits abgelaufen.
                <br><br>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            price: {
                type: [Number,String],
                default: 0
            },
            startprice: {
                type: [Number,String],
                default: 0
            },
            profit: {
                type: [Number,String],
                default: ''
            },
            productid: {
                type: [Number,String],
                default: ''
            },
            minbid: {
                type: [Number,String],
                default: ''
            },
        },

        data () { 
            return {
               prices: [],
               priceLast: 0,
               lastBid: 0,
               selected: 0,
               calculation: false,
               logedin: false,
               ended: true,
               login: false,
               iBid: false,
               initialized: false
            }
        },

        mounted: function() {
            App.socket.on('12meins-channel:App\\Events\\UserBid', (data) => {
                if(this.productid == data.productId) {
                    if(this.iBid && this.minbid && this.lastBid < this.minbid && data.bid >= this.minbid) {
                        swal({ 
                            html:true, 
                            title:'', 
                            text:'Sie haben das Mindestgebot erreicht',
                            type: "success"
                        });
                    }
                    
                    this.prices = [];
                    this.lastBid = data.bid;
                    this.priceLast = data.bid;
                    this.createDropdownValues(data.bid);
                    this.iBid = false;
                }
            });
        },

        methods: {
            createDropdownValues(startPrice) {
                for(let i=0; i<10; i++) {
                    if(parseInt(this.priceLast) < parseInt(this.startprice) && i == 0) {
                        startPrice = this.startprice;
                        this.prices.push(startPrice);
                    } else {
                        if(startPrice < 5) {
                            startPrice = parseInt(startPrice) + 1;
                            this.prices.push(startPrice);
                        } else if(startPrice >= 5 && startPrice < 50) {
                            startPrice = parseInt(startPrice) + 5;
                            this.prices.push(startPrice);
                        } else if(startPrice >= 50 && startPrice < 200) {
                            startPrice = parseInt(startPrice) + 10;
                            this.prices.push(startPrice);
                        } else if(startPrice >= 200 && startPrice < 500) {
                            startPrice = parseInt(startPrice) + 20;
                            this.prices.push(startPrice);
                        } else if(startPrice >= 500 && startPrice < 1000) {
                            startPrice = parseInt(startPrice) + 50;
                            this.prices.push(startPrice);
                        } else if(startPrice >= 1000 && startPrice < 1500) {
                            startPrice = parseInt(startPrice) + 100;
                            this.prices.push(startPrice);
                        } else if(startPrice >= 1500 && startPrice < 10000) {
                            startPrice = parseInt(startPrice) + 200;
                            this.prices.push(startPrice);
                        } else if(startPrice >= 10000 && startPrice < 30000) {
                            startPrice = parseInt(startPrice) + 500;
                            this.prices.push(startPrice);
                        } else if(startPrice >= 30000 && startPrice < 100000) {
                            startPrice = parseInt(startPrice) + 1000;
                            this.prices.push(startPrice);
                        } else {
                            startPrice = parseInt(startPrice) + 5000;
                            this.prices.push(startPrice);
                        }
                    }
                    if(i == 0) {
                        this.selected = startPrice;
                    }
                }
            },

            selectPrice(price) {
                this.selected = price;
            },

            hideCalculation() {
                this.calculation = false;
            },

            checkLogin() {
                new Form().get('/api/me')
                    .then(user => {
                        if(user != "") {
                            this.calculation = true;
                        } else {
                            this.calculation = true;
                            this.login = true;
                        }
                            
                    });
            },

            bidSelectedValue() {
                this.iBid = true;
                new Form({id: this.productid, bid: this.selected}).post('/api/bid').then((response) => {
                    this.calculation = false;
                    if(response == -1) {
                        swal({ 
                                html:true, 
                                title:'', 
                                text:'Während Sie offline waren, ist die Zeit für dieses Produkt bereits abgelaufen.',
                                type: "error"
                            });
                    } else if(response > 0) {
                        if(this.minbid > response) {
                            swal({ 
                                html:true, 
                                title:'', 
                                text:'Mindestgebot wurde nicht erreicht',
                                type: "error"
                            });
                        }
                    
                        App.event.fire('bid.newhighestbid.user', {
                            bid: response,
                            productId: this.productid
                        });
                    } else {
                        swal({ 
                            html:true, 
                            title:'', 
                            text:'Während Sie offline waren, wurde bereits ein höheres Gebot abgegeben.<br>Neues Höchstegebot ist: €'+this.lastBid,
                            type: "error"
                        });
                    }
                });
            }
        },

        created () {
            let startPrice = this.price;
            this.lastBid = this.price;
            this.priceLast = this.price;
            this.createDropdownValues(startPrice);

            App.event.listen('timer.ended', ({ended, productId}) => {
                if(this.productid == productId) {
                    this.ended = ended;
                    this.initialized = true;
                }
            });

            App.event.listen('show-login', (response) => {
                if(response == this.productid) {
                    this.login = true;
                }
            });

            App.event.listen('login.success', (response) => {
                this.login = false;
            });
        },

        computed: {
            selectedPrice() {
                return parseFloat(this.selected).toFixed(2);
            },
            profitSum() {
                let profit = parseFloat(this.selected) * (parseFloat(this.profit) / 100);
                return parseFloat(profit).toFixed(2);
            },
            vat() {
                let vat = (parseFloat(this.selected) + parseFloat(this.profitSum)) * 0.2;
                return parseFloat(vat).toFixed(2);
            },
            total() {
                let total = parseFloat(this.selected) + parseFloat(this.profitSum) + parseFloat(this.vat);
                return parseFloat(total).toFixed(2);
            }
        }
    }
</script>
